import { atom } from 'jotai'

export const facebookErrorsAtom = atom<string[] | null>(null)
